import React from "react";
import ReactPaginate from "react-paginate";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

export default function Pagination({ 
  pageCount = 10, 
  currentPage = 0, 
  onPageChange = () => {},
  marginPagesDisplayed = 1,
  pageRangeDisplayed = 3
}) {
  const handlePageClick = (event) => {
    onPageChange(event.selected);
  };

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel={<RiArrowRightSLine className="size-6 text-secondary/70" />}
      previousLabel={<RiArrowLeftSLine className="size-6 text-secondary/70" />}
      onPageChange={handlePageClick}
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={marginPagesDisplayed}
      pageCount={pageCount}
      forcePage={currentPage}
      renderOnZeroPageCount={null}
      className="flex items-center gap-1.5"
      pageClassName="flex"
      pageLinkClassName="flex items-center bg-white border justify-center size-10 rounded-full text-16 text-secondary/80 hover:bg-secondary/10 transition-colors select-none"
      activeLinkClassName="!bg-primary border !border-primary !text-white"
      previousClassName="flex"
      nextClassName="flex"
      previousLinkClassName="flex items-center justify-center size-10 rounded-full text-secondary hover:bg-secondary/5 transition-colors bg-white border"
      nextLinkClassName="flex items-center justify-center size-10 rounded-full text-secondary hover:bg-secondary/5 transition-colors bg-white border"
      breakClassName="flex items-center justify-center text-secondary/70 text-16 bg-secondary/5 rounded-full size-10"
      disabledClassName="opacity-50 cursor-not-allowed"
      disabledLinkClassName="hover:bg-transparent cursor-not-allowed"
    />
  );
}
